{
  "schemaVersion": "qec-trace-0.3",
  "engineVersion": "1.0.0",
  "pathMapVersion": "qec-path-map-0.3.0",
  "manifestationVersion": "qec-manifestation-0.2",
  "program": "אור",
  "programHash": "fnv1a32-ddb3d910",
  "seed": 13,
  "initialState": [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    13
  ],
  "events": [
    {
      "sequence": 0,
      "instructionIndex": 0,
      "letter": "א",
      "transform": "preserve-frame",
      "route": [
        "Keter",
        "Tiferet"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "KeterService",
        "TiferetScheduler"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        13
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        13
      ],
      "beforeHash": "fd6f6d59",
      "afterHash": "fd6f6d59",
      "coherence": {
        "activation": 0.318,
        "phase": 0.683,
        "coherence": 0.864
      }
    },
    {
      "sequence": 1,
      "instructionIndex": 1,
      "letter": "ו",
      "transform": "mirror-exchange",
      "route": [
        "Hod",
        "Yesod"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "HodInterface",
        "YesodBus"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        13
      ],
      "after": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        13
      ],
      "beforeHash": "fd6f6d59",
      "afterHash": "3ddeccf3",
      "coherence": {
        "activation": 0.441,
        "phase": 4.44,
        "coherence": 0.698
      }
    },
    {
      "sequence": 2,
      "instructionIndex": 2,
      "letter": "ר",
      "transform": "seed-rotation",
      "route": [
        "Yesod",
        "Malchut"
      ],
      "services": [
        "BinahCompiler",
        "GevurahPolicy",
        "YesodBus",
        "MalchutOutput"
      ],
      "before": [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        0,
        0,
        0,
        2,
        4,
        0,
        0,
        2,
        0,
        0,
        0,
        13
      ],
      "after": [
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13
      ],
      "beforeHash": "3ddeccf3",
      "afterHash": "9e082353",
      "coherence": {
        "activation": 0.261,
        "phase": 6.187,
        "coherence": 0.852
      }
    }
  ],
  "completeTraceHash": "fnv1a32-5f7166ff",
  "observation": {
    "step": 3,
    "reason": "program-end",
    "stateHash": "24cfacfa",
    "traceHash": "fnv1a32-5f7166ff",
    "candidates": [
      {
        "id": "register-order",
        "label": "Register order",
        "stateHash": "19cf9ba9",
        "focusLetter": "ע",
        "confidence": 0.912,
        "rationale": "Reads the manifested registers in machine order."
      },
      {
        "id": "mirror-order",
        "label": "Mirror order",
        "stateHash": "5f639018",
        "focusLetter": "ג",
        "confidence": 0.523,
        "rationale": "Reads the same state through its paired-register reflection."
      },
      {
        "id": "phase-offset",
        "label": "Aleph Olam phase",
        "stateHash": "d47bdc6d",
        "focusLetter": "ת",
        "confidence": 0.893,
        "rationale": "Projects the state through the shared Aleph Olam orientation."
      }
    ],
    "selectedProjection": "register-order",
    "snapshot": [
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13
    ]
  }
}
